export * from "-!../../_vue-loader@15.7.0@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../_vue-loader@15.7.0@vue-loader/lib/index.js??vue-loader-options!./Monaco.vue?vue&type=template&id=41d0567f&"


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/src/Monaco.vue?vue&type=template&id=41d0567f&
// module id = ./node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/src/Monaco.vue?vue&type=template&id=41d0567f&
// module chunks = 1